import BaseModel from './base';

import {
  POLLS_RIGHTS,
  POLLS_SETTINGS_RIGHTS,
  POLLS_RIGHTS_ANNOTATIONS,
} from '@/modules/Events/constants';

export default class PollRights extends BaseModel {
  constructor(pollRights, url) {
    super(pollRights, url);

    // Данные для задания
    this.level = pollRights.level; // уровень мероприятия
    this.event_stage_id = pollRights.event_stage_id;
    this.poll_id = pollRights.poll_id;
    this.event_nomination_id = pollRights.event_nomination_id;
    this.publish_at = pollRights.publish_at; // этапа (наверное)
    this.ending_at = pollRights.ending_at; // этапа (наверное)

    // Настройки задания (опции, которые при прикреплении к этапу)
    this.attempts_count = pollRights.asked_question_count;
    this.is_moderated = pollRights.is_moderated;
    this.passing_score = pollRights.passing_score;
    this.minutes_to_solve = pollRights.minutes_to_solve;
    this.asked_question_count = pollRights.asked_question_count;
    this.max_additional_attempts = pollRights.max_additional_attempts;
    this.is_public_member_profile = pollRights.is_public_member_profile;

    // Сами права
    this.right = pollRights.right || POLLS_RIGHTS.RECOMMEND;
    this.settings_right = pollRights.settings_right || POLLS_SETTINGS_RIGHTS.RECOMMEND;
  }

  get rightPollAnnotation() {
    return POLLS_RIGHTS_ANNOTATIONS[this.right];
  }

  get canRemovePoll() {
    return ![
      POLLS_RIGHTS.REQUIRED_WITHOUT_YOURS,
      POLLS_RIGHTS.REQUIRED_WITH_YOURS,
    ].includes(this.right);
  }

  get isDisabledPoll() {
    return this.right === POLLS_RIGHTS.UNAVAILABLE;
  }

  get cannotAttachOtherPolls() {
    return this.right === POLLS_RIGHTS.REQUIRED_WITHOUT_YOURS;
  }

  get isRequiredSettings() {
    return this.settings_right === POLLS_SETTINGS_RIGHTS.REQUIRED;
  }
}
